import { copilotQuotaQuery } from '@affine/graphql';
import { Store } from '@toeverything/infra';

import type { GraphQLService } from '../services/graphql';
import { getCookie, getVisitorIdByCookie } from '../server/utils';
import { apiVersion, getCoreUrl } from '../server/config';
import request from '../server/base';

export class UserCopilotQuotaStore extends Store {
  constructor(private readonly graphqlService: GraphQLService) {
    super();
  }

  async fetchUserCopilotQuota(abortSignal?: AbortSignal) {
    const visitorId = getVisitorIdByCookie();
    const auth = getCookie('login')
      ? JSON.parse(decodeURIComponent(getCookie('login') || '') || '')
      : null;
    const config = {
      url: `${getCoreUrl(apiVersion)}/agent/usage`,
      method: 'GET',
      headers: {
        'X-Yuanshi-Authorization': 'Bearer ' + auth?.token,
        'X-Yuanshi-DeviceId': visitorId,
        // userId: auth?.user?.id,
      },
    };
    const res = await request(config);

    // const data = await this.graphqlService.gql({
    //   query: copilotQuotaQuery,
    //   context: {
    //     signal: abortSignal,
    //   },
    // });

    if (!res?.data?.currentUser) {
      throw new Error('No logged in');
    }

    return res?.data?.currentUser?.copilot;
  }
}
